import React, { Component, PropTypes } from 'react';
import { browserHistory, withRouter } from 'react-router';
import { connect } from 'react-redux';
import { fetchCampaign, fetchSalesChannels, fetchProducts } from '../actions/';
import autoBind from 'react-autobind';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import baseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import ViewCampaign from '../components/campaigns/ViewCampaign';

const propTypes = {
  dispatch: PropTypes.func.isRequired,
  isAuthenticated: PropTypes.bool.isRequired,
  campaigns: PropTypes.object,
  productsMeta: PropTypes.object,
  params: PropTypes.object,
  error: PropTypes.any,
  query: PropTypes.object.isRequired,
};

class CampaignViewPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertOpen: false,
      alertMessage: '',
      edited: false,
    };
    autoBind(this);
  }
  getChildContext() {
    return { muiTheme: getMuiTheme(baseTheme) };
  }
  componentWillMount() {
    if (!this.props.isAuthenticated) {
      browserHistory.push('/');
    }
  }
  componentDidMount() {
    this.props.dispatch(fetchCampaign(this.props.params.id));
    this.props.dispatch(fetchSalesChannels({ limit: 1000 }));
    this.props.dispatch(fetchProducts({ limit: 1000, campaignId: this.props.params.id }));
  }
  navigation(route) {
    this.props.dispatch(fetchProducts(route));
  }
  render() {
    const authPage = {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
    };
    return (
      <div className="campaign component" style={authPage}>
        <ViewCampaign
          campaign={this.props.campaigns.campaign}
          productsMeta={this.props.productsMeta}
          navigation={route => this.navigation(route)}
        />
      </div>
    );
  }
}

CampaignViewPage.childContextTypes = {
  muiTheme: PropTypes.object.isRequired,
};

CampaignViewPage.propTypes = propTypes;

function mapStateToProps(state, ownProps) {
  return {
    isAuthenticated: state.auth.isAuthenticated,
    campaigns: state.campaigns,
    query: ownProps.location.query,
    productsMeta: state.products.meta,
  };
}

export default withRouter(connect(mapStateToProps)(CampaignViewPage));



// WEBPACK FOOTER //
// ./src/containers/CampaignViewPage.js